// @flow strict

/**
 * @summary App storage
 * @description Handles storing/retrieving things between sessions
 * @type {[type]}
 */

/** Main storage for app */
const storage: window.localStorage = window.localStorage

/**
 * Set a value in "storage"
 * @param {string} id - ID of item to set
 * @param {string} value - Value of item to set
 * @returns {boolean} - Whether or not the item was saved
 */
export const set = (id: string, value: string): boolean => {
  if (storage) {
    storage.setItem(id, value)
    return true
  } else {
    return false
  }
}

/**
 * Retrieve an item from storage
 * @param {string} id - ID of item to retrieve
 * @returns {null|string} - Item or `null`
 */
export const get = (id: string): ?string => {
  if (storage) {
    return storage.getItem(id) || null
  } else {
    return null
  }
}

/**
 * Remove an item from storage
 * @param {string} id - ID of item to retrieve
 * @returns {null|string} - Item or `null`
 */
export const remove = (id: string): ?string => {
  if (storage) {
    return storage.removeItem(id) || null
  } else {
    return null
  }
}
